// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1Vgd0","productName":"Table_productName__3Rrpa"};